<template>
    <div>
        <template v-if="user">
            <div class="float-left"><img class="profile-picture profile-picture-square" v-auth-image="user.ProfilePictureUrl"/></div>
            <div class="float-left">
                <div>{{user.FirstName}} {{user.LastName}}</div>
                <small class="text-muted" v-if="user.Title">{{user.Title.Name}}</small>
            </div>
        </template>
        <template v-else>
            <div class="text-info">{{translate('messages.clickToSelectUser')}}</div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        user: Object
    }
}
</script>

<style scoped>
.profile-picture {
    width:48px;
    height:48px;
    margin-right: 16px;
}
</style>